import { useMemo } from "react"

import {
  createSimulationWrapperInstance,
  SimulationWrapperType,
} from "@/test-set/simulation-wrappers"

import { useTestSetEditorContext } from "../contexts/TestSetEditorContext"

export function useTestSetSimulationWrapper() {
  const { featureFlags, metadata } = useTestSetEditorContext()
  const wrapperType =
    metadata.simulationWrapperType ||
    (featureFlags.isApiSimulationWrapperEnabled
      ? SimulationWrapperType.API_WRAPPER
      : null)
  const isApiUnavailable =
    wrapperType === SimulationWrapperType.API_WRAPPER &&
    !featureFlags.isApiSimulationWrapperEnabled
  return useMemo(() => {
    if (!wrapperType || isApiUnavailable) {
      return null
    }
    return createSimulationWrapperInstance(wrapperType)
  }, [wrapperType, isApiUnavailable])
}
